import { Injectable } from '@angular/core';
import {
  TixConfirmReservationGQL,
  TixCreatePaymentIntentForOrderGQL,
  TixCreateUnconfirmedReservationGQL,
  TixCustomerInput,
  TixGetAmountToPayForOrderGQL,
  TixOrderInput,
  TixPaymentMethod
} from '@tix/data-access';
import { map } from 'rxjs/operators';

@Injectable()
export class OrderPaymentService {
  constructor(
    private readonly createPaymentIntentForOrderMutation: TixCreatePaymentIntentForOrderGQL,
    private readonly createUnconfirmedReservationMutation: TixCreateUnconfirmedReservationGQL,
    private readonly confirmReservationMutation: TixConfirmReservationGQL,
    private readonly getAmountToPayQuery: TixGetAmountToPayForOrderGQL
  ) {}

  async getAmountToPayForOrder({
    order,
    eventInstanceId
  }: {
    order: TixOrderInput;
    eventInstanceId: string;
  }) {
    const res = await this.getAmountToPayQuery
      .fetch({ order, eventInstanceId })
      .toPromise();
    return res.data.getAmountToPayForOrder;
  }

  createPaymentIntentForOrder({
    eventInstanceId,
    order
  }: {
    eventInstanceId: string;
    order: TixOrderInput;
  }) {
    return this.createPaymentIntentForOrderMutation
      .mutate({
        eventInstanceId,
        order
      })
      .pipe(map(res => res.data?.createPaymentIntentForOrder));
  }

  createUnconfirmedReservation({
    eventInstanceId,
    order,
    customer,
    paymentIntentId
  }: {
    eventInstanceId: string;
    order: TixOrderInput;
    customer: TixCustomerInput;
    paymentIntentId?: string;
  }) {
    return this.createUnconfirmedReservationMutation
      .mutate({
        eventInstanceId,
        order,
        customer,
        paymentIntentId
      })
      .pipe(map(res => res.data?.createUnconfirmedReservation));
  }

  confirmReservation({
    reservationId,
    paymentIntentId
  }: {
    reservationId: string;
    paymentIntentId?: string;
  }) {
    return this.confirmReservationMutation
      .mutate({
        reservationId,
        method: TixPaymentMethod.StripeOnline,
        paymentIntentId
      })
      .pipe(map(res => res.data?.confirmReservation));
  }
}
